import {AddToolboxOutline, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalItem} from "./PortalItem";

export class PortalAddToolboxOutline extends AddToolboxOutline implements Parameter {
	constructor(data: any) {
		super(data);

		this.item = FunctionHelper.applyValue(
			data.item, AddToolboxOutline.getItemDefault()
		).map(PortalItem.fromJson);
	}

	public static fromJson(data: any): PortalAddToolboxOutline {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalAddToolboxOutline(data);
	}

	public clone(): PortalAddToolboxOutline {
		return PortalAddToolboxOutline.fromJson(this.toJson());
	}
}